import React, { useEffect, useRef, useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';
import styles from '@/modules/admin-access-codes/styles.less';

const CodeCell = ({ value }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const resetTimeoutRef = useRef(null);

  useEffect(() => () => {
    if (resetTimeoutRef.current) {
      clearTimeout(resetTimeoutRef.current);
    }
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      if (resetTimeoutRef.current) {
        clearTimeout(resetTimeoutRef.current);
      }
      resetTimeoutRef.current = setTimeout(() => {
        setCopied(false);
        resetTimeoutRef.current = null;
      }, 2000);
    } catch (error) {
      console.error(t('Failed to copy access code'));
    }
  };

  return (
    <div className={styles.codeCell}>
      <span>{value}</span>
      {copied ? <CheckIcon onClick={handleCopy} /> : <ContentCopyIcon onClick={handleCopy} />}
    </div>
  );
};

export const renderCodeCell = ({ value }) => <CodeCell value={value} />;
